import React, { useMemo } from 'react';
import AccountSection from './components/AccountSection';
import './styles.css';

const AccountSections = props => {
  const { selected, restricted = false, onClick, sections, restrictedSections } = props;

  const items = useMemo(
    () =>
      sections
        .filter(
          item => {
            return (restrictedSections.indexOf(item.name) === -1 || !restricted) && item.visible;
          }
        )
        .map((item, index) => (
          <AccountSection
            key={index}
            disabled={item.disabled}
            data={item.name === selected ? { ...item, selected: true } : item}
            onClick={onClick}
          />
        )),
    [selected]
  );

  return (
    <div className="global-search-filters">
      <div className="global-search-filters__list">{items}</div>
    </div>
  );
};

export default AccountSections;
